import { Box, colors } from '@bridebook/ui';
import { Button } from '@bridebook/ui/src/components/bbcommon/button/button';
import componentStyles from './gallery-modal.style';
import { IconBack, IconCross } from '@bridebook/ui/src/icons';
import { useState } from 'react';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import {
  getAllSupplierPhotos,
  getSupplierVideos,
  getSupplierVideoTours,
} from '@bridebook/web/app-basic/lib/supplier/selectors';
import GridGallery from './grid-gallery';
import { useRouter } from 'next/router';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { getIsDesktop } from '@bridebook/web/app-basic/lib/app/selectors';
import BrochureRequest from '../sticky-brochure-request/brochure-request';
import { useTranslation } from 'next-i18next';
import { Icon } from '@bridebook/aura';
import { Heart } from '@bridebook/aura/src/icons';

interface IProps {
  onBack: () => void;
}

const GalleryModal = ({ onBack }: IProps) => {
  const { t } = useTranslation('supplier');

  const [showContact, setShowContact] = useState(true);
  const styles = componentStyles();

  const isDesktop = useSelector(getIsDesktop);
  const router = useRouter();

  const photos = useSelector(getAllSupplierPhotos).map(({ path, portrait }) => ({
    path,
    portrait,
  }));

  const videosCount = useSelector(getSupplierVideos).length;
  const virtualToursCount = useSelector(getSupplierVideoTours).length;

  const onClick = () => {
    router.push(UrlHelper.signup);
  };

  return (
    <Box style={styles.container}>
      <Box style={styles.toolbar}>
        <Button w={32} h={32} variant="ghost" color="mint" onClick={onBack}>
          <IconBack
            fillOpacity={1}
            color={colors.space75}
            borderColor={colors.space08}
            width={32}
          />
        </Button>
        <Box style={styles.optionsBox}>
          <Button styleWrapper={styles.optionBtn} size="small" variant="primary">
            {t('galleryModal.photos', { photosCount: photos.length })}
          </Button>
          {videosCount > 0 && (
            <Button
              styleWrapper={styles.optionBtn}
              size="small"
              variant="secondary"
              onClick={onClick}>
              {t('galleryModal.videos', { videosCount })}
            </Button>
          )}
          {virtualToursCount > 0 && (
            <Button
              styleWrapper={styles.optionBtn}
              size="small"
              variant="secondary"
              onClick={onClick}>
              {t('galleryModal.virtualTours', { virtualToursCount })}
            </Button>
          )}
          {isDesktop && (
            <Button
              styleWrapper={styles.optionBtn}
              size="small"
              variant="secondary"
              onClick={onClick}
              startIcon={<Icon icon={Heart} size={16} />}>
              {t('galleryModal.favourite')}
            </Button>
          )}
        </Box>
      </Box>
      <Box style={styles.galleryContainer}>
        <Box style={styles.galleryBox}>
          <GridGallery photos={photos} onImageClick={onClick} />
          {showContact && isDesktop && (
            <Box style={styles.contactBox}>
              <Box as="button" onClick={() => setShowContact(false)} style={styles.contactClose}>
                <IconCross width={16} />
              </Box>
              <Box style={styles.contactIcon}>💒</Box>
              <Box style={styles.contactTitle}>{t('galleryModal.contact.title')}</Box>
              <Box style={styles.contactDescription}>{t('galleryModal.contact.description')}</Box>
              <Button onClick={onClick}>{t('galleryModal.contact.button')}</Button>
            </Box>
          )}
          {!isDesktop && (
            <Box style={styles.contactMobile}>
              <BrochureRequest />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default GalleryModal;
